var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7273 4.45455H8.71182L9.31636 1.54636L9.33545 1.34273C9.33545 1.08182 9.22727 0.84 9.05545 0.668182L8.38091 0L4.19364 4.19364C3.95818 4.42273 3.81818 4.74091 3.81818 5.09091V11.4545C3.81818 12.1545 4.39091 12.7273 5.09091 12.7273H10.8182C11.3464 12.7273 11.7982 12.4091 11.9891 11.9509L13.9109 7.46455C13.9682 7.31818 14 7.16545 14 7V5.72727C14 5.02727 13.4273 4.45455 12.7273 4.45455ZM12.7273 7L10.8182 11.4545H5.09091V5.09091L7.85273 2.32909L7.14636 5.72727H12.7273V7ZM0 5.09091H2.54545V12.7273H0V5.09091Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.62006bea1788d492792f5ca76a545678.svg";
export { ForwardRef as ReactComponent };